import { render, staticRenderFns } from "./CCIconfont.vue?vue&type=template&id=23be6ff5&scoped=true"
import script from "./CCIconfont.vue?vue&type=script&lang=js"
export * from "./CCIconfont.vue?vue&type=script&lang=js"
import style0 from "./CCIconfont.vue?vue&type=style&index=0&id=23be6ff5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23be6ff5",
  null
  
)

export default component.exports